/*
Dodaje obsługę dla drzewa checkboxów, które wykorzystywane jest w edycji usługi DDoS w edycji firmy.

metody:
ApiCheckboxTree.init();
*/

class ApiCheckboxTree {
    static init() {
        $('.checkbox-tree:not(.deletable) > li > .checkbox input').on('click', function() {
            if ($(this).prop('checked')) {
                $(this).closest('li').find('ul input').prop('checked', 1);
            } else {
                $(this).closest('li').find('ul input').prop('checked', 0);
            }
        });
    }
}
